module.exports = __webpack_public_path__ + "static/media/Download-logo.7bae41a4.png";